<template>
  <v-container fluid class="mt-2 pa-0">
    <v-row>
      <v-col cols="12" md="12" v-if="showSelf">
        <el-switch
          label="Ieškoti pagal save"
          tooltip="Paieška. Fizinis. Pagal save"
          v-model="self"
        />
      </v-col>
      <v-col cols="12" md="12" class="mb-2">
        <el-switch
          label="LR Juridinių asmenų registre neregistruotas asmuo"
          tooltip="Paieška. Juridinis. Neregistruotas"
          v-model="mainData.foreign"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          :readonly="isSelf"
          required
          label="Juridinio asmens kodas"
          tooltip="Paieška. Juridinis. Juridinio asmens kodas"
          v-model="mainData.asm_asmens_kodas"
          autofocus
        />
      </v-col>
      <v-col cols="12" md="6" v-if="isForeign">
        <el-autocomplete
          required
          :items="salisList"
          itemvalue="value"
          itemtext="text"
          return-object
          label="Užsienio valstybė"
          tooltip="Paieška. Juridinis. Užsienio valstybė JUR"
          v-model="salisSelect"
        />
      </v-col>
      <!-- <v-col cols="12" md="6">
        <el-text-field
          label="Pavadinimas"
          tooltip="Paieška. Juridinis. Pavadinimas"
          v-model="mainData.asm_pavadinimas"
        />
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'

export default {
  name: 'PaieskaJuridinis',
  mixins: [userRole],
  props: {
    mainData: Object,
    salys: Array,
  },
  data() {
    return {
      salisSelect: {},
      self: false,
    }
  },
  $_veeValidate: {
    validator: '$validator',
  },
  watch: {
    salisSelect(val) {
      this.mainData.asm_vls_kodas = val.value
      this.mainData.asm_vls_tekstas = val.text
    },
    self(value) {
      this.mainData.self = value
      if (value) {
        this.mainData.foreign = this.paieskaSelf.foreign
        this.mainData.asm_asmens_kodas = this.paieskaSelf.asm_kodas
      }
    },
  },
  computed: {
    ...mapGetters(['paieskaSelf']),
    salisList() {
      return this.salys
    },
    isForeign() {
      return (this.mainData && this.mainData.foreign) ?? false
    },
    isSelf() {
      return this.self
    },
    showSelf() {
      return this.role('EL_JA')
    },
  },
  methods: {
    getData() {
      this.$axios
        .get(this.asmenysUrl)
        .then(res => {
          this.salys = res.data.salys
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
    },
  },
}
</script>
<style lang="scss" scoped></style>
